export const routes = (parentName) => {
  return [
    {
      path: "agahi",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "new",
          name: `${parentName}-Agahi-New`,
          component: () => import("./Upsert.vue"),
        },
      ],
    },
  ];
};
